/**
 * Transport for the static LLM catalogue (`GET /api/debate/models`).
 *
 * Cached in-module after the first successful fetch — the catalogue rarely
 * changes within a session and the response is tiny.
 */
import type { ModelCatalogEntry } from "../domain/types";

const ENDPOINT = "/api/debate/models";

interface CatalogResponse {
  default: string;
  models: ModelCatalogEntry[];
}

let _cache: CatalogResponse | null = null;
let _inflight: Promise<CatalogResponse> | null = null;

export async function fetchModelsCatalog(
  options: { signal?: AbortSignal } = {},
): Promise<CatalogResponse> {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = (async () => {
    const init: RequestInit = {
      method: "GET",
      headers: { Accept: "application/json" },
      cache: "no-store",
      credentials: "include",
    };
    if (options.signal) init.signal = options.signal;
    const resp = await fetch(ENDPOINT, init);
    if (!resp.ok) {
      _inflight = null;
      throw new Error(`models HTTP ${resp.status}`);
    }
    const payload = (await resp.json()) as CatalogResponse;
    _cache = payload;
    _inflight = null;
    return payload;
  })();
  return _inflight;
}

export function getCachedCatalog(): CatalogResponse | null {
  return _cache;
}
